import Backbone from 'backbone'

import tpl from './header.mustache'

export var HeaderView = Backbone.View.extend({
  template: tpl,
  events: {
    'click .sub-title__backbtn': 'moveBack',
  },
  initialize: function () {
    // this.model.off()
    this.model.on('sync', this.render, this)
    this.model.on('change:onSubmenu', this.subMenuChange, this)
    this.model.fetch()
  },
  subMenuChange: function () {
    var onName = 'on'
    var $subMenuLi = this.$el.find('li')
    var limit = $subMenuLi.length
    var current = this.model.get('onSubmenu')

    $subMenuLi.removeClass(onName)
    $subMenuLi.eq(current).addClass(onName)
    if (current >= limit) $subMenuLi.eq(0).addClass(onName)
  },
  render: function () {
    var rendered = this.template.render(this.model.toJSON())
    this.$el.html(rendered)
    this.subMenuChange()
    return this
  },
})
